<template>
  <div class="danh-sach-nguoi-dung-theo-vai-tro">
    <form @submit.prevent>
      <div class="row">
        <b-form-group label-for="filterBy" class="border-bottom-form col-12">
          <div class="d-flex align-items-center">
            <label class="label-table m-0 flex-1-0"
              >Danh sách người dùng trong vai trò</label
            >
            <base-button
              v-if="
                !readonly &&
                hasPermissionUser(PERMISSION_NAME.VAI_TRO.THEM_NGUOI_DUNG)
              "
              class="btn search-information-btn d-block ml-2"
              button="Thêm người dùng"
              color="btn-success"
              @click="moFormThemDanhSachNguoiDung()"
            >
              Thêm người dùng
            </base-button>
            <base-button
              v-if="
                !readonly &&
                hasPermissionUser(PERMISSION_NAME.VAI_TRO.XOA_NGUOI_DUNG)
              "
              :disabled="danhSachIdNguoiDungDaChon.length === 0"
              class="btn search-information-btn d-block"
              button="Xóa người dùng đã chọn"
              @click="xoaDanhSachNguoiDung()"
            >
              Xóa vai trò đã chọn
            </base-button>
          </div>
        </b-form-group>
      </div>
    </form>
    <div class="box-form-result">
      <DataTable
        :value="danhSachNguoiDungNoiBo"
        :loading="isLoadingTable"
        :selection.sync="selectedCanBo"
        :rowClass="rowClass"
      >
        <Column
          field="id"
          headerStyle="width: 40px"
          header=""
          bodyStyle="text-align: center"
          bodyClass="select-column"
          selectionMode="multiple"
          v-if="!readonly"
          :filter-header-class="readonly ? 'd-none' : ''"
          :body-class="readonly ? 'd-none' : ''"
          :header-class="readonly ? 'd-none p-2' : 'p-2'"
        >
        </Column>
        <Column
          field="stt"
          dataKey="stt"
          headerStyle="width: 40px"
          headerClass="p-2"
          header="STT"
          bodyStyle="text-align: center"
        >
          <template #filter> </template>
          <template #body="slotProps">
            <span>{{
              (requestInformation.pageIndex - 1) * requestInformation.pageSize +
              slotProps.index +
              1
            }}</span>
          </template>
        </Column>
        <Column
          filterMatchMode="custom"
          field="userName"
          header="Tên đăng nhập"
          headerStyle="minWidth: 200px"
        >
          <template #filter>
            <InputText
              type="text"
              class="p-column-filter"
              placeholder="Tìm kiếm"
              v-model="requestInformation.UserName"
              @change="layDanhSachNguoiDung"
            />
          </template>
          <template #body="slotProps">
            <span>{{ slotProps.data.userName }}</span>
          </template>
        </Column>

        <Column
          filterMatchMode="custom"
          field="name"
          header="Họ tên"
          headerStyle="minWidth: 200px"
        >
          <template #filter>
            <InputText
              type="text"
              class="p-column-filter"
              placeholder="Tìm kiếm"
              v-model="requestInformation.FullName"
              @change="layDanhSachNguoiDung"
            />
          </template>
          <template #body="slotProps">
            <span>{{ slotProps.data.name }}</span>
          </template>
        </Column>

        <Column
          filterMatchMode="custom"
          field="donVi"
          header="Đơn vị"
          headerStyle="minWidth: 200px"
        >
          <template #filter>
            <InputText
              type="text"
              class="p-column-filter"
              placeholder="Tìm kiếm"
              v-model="requestInformation.donVi"
              @change="layDanhSachNguoiDung"
            />
          </template>
          <template #body="slotProps">
            <span>{{ slotProps.data.donVi }}</span>
          </template>
        </Column>
        <Column
          filterMatchMode="custom"
          field="chucVu"
          header="Chức vụ"
          headerStyle="minWidth: 200px"
        >
          <template #filter>
            <InputText
              type="text"
              class="p-column-filter"
              placeholder="Tìm kiếm"
              v-model="requestInformation.chucVu"
              @change="layDanhSachNguoiDung"
            />
          </template>
          <template #body="slotProps">
            <span>{{ slotProps.data.chucVu }}</span>
          </template>
        </Column>
        <Column
          filterMatchMode="custom"
          field="thaoTac"
          header="Thao tác"
          headerStyle="width: 100px"
          v-if="
            !readonly &&
            hasPermissionUser(PERMISSION_NAME.VAI_TRO.XOA_NGUOI_DUNG)
          "
        >
          <template #body="slotProps">
            <div class="text-center">
              <font-awesome-icon
                icon="trash-alt"
                v-if="
                  slotProps.data.canDelete &&
                  hasPermissionUser(PERMISSION_NAME.VAI_TRO.XOA_NGUOI_DUNG)
                "
                v-b-popover.hover.top="'Xóa nhóm người dùng'"
                class="cursor-pointer color-red ml-2"
                @click="xoaNguoiDung(slotProps.data.id)"
              />
            </div>
          </template>
        </Column>
        <template #empty
          ><div class="text-center">Không có dữ liệu</div></template
        >
        <template #loading
          ><div class="text-center">Đang tải dữ liệu ...</div>
        </template>
      </DataTable>
    </div>
    <BasePagination
      :total-pages="totalPages"
      :total-rows="totalRows"
      :current-page="requestInformation.pageIndex"
      @changePages="onChangePages($event)"
      @changeNum="onChangeNum($event)"
    />
    <XoaNguoiDungModal
      @xoaDanhSachNguoiDungTrongVaiTro="xoaDanhSachNguoiDungTrongVaiTro"
    />
    <b-modal
      id="them-nguoi-dung-modal"
      size="xl"
      title="Danh sách người dùng hệ thống"
      :hide-footer="true"
    >
      <DanhSachNguoiDungHeThong
        ref="danhSachNguoiDungHeThong"
        @close="dongFormThemDanhSachNguoiDung"
        @layDanhSachNguoiDungTheoVaiTro="layDanhSachNguoiDung"
      />
    </b-modal>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import _isEmpty from "lodash/isEmpty";
import _cloneDeep from "lodash/cloneDeep";
import _isNil from "lodash/isNil";
import {
  LOI_CHUA_CHON_NGUOI_DUNG,
  XOA_NGUOI_DUNG_THANH_CONG,
} from "@/constants/message";
import QuanLyNguoiDung from "@/mixins/QuanLyNguoiDung";
import XoaNguoiDungModal from "@/components/pages/quan-tri-he-thong/nguoi-dung/XoaNguoiDungModal";
import DanhSachNguoiDungHeThong from "@/components/pages/quan-tri-he-thong/nguoi-dung/DanhSachNguoiDungKhongThuocVaiTro";
import {
  NO_RESULTS_TEXT,
  TREE_SELECT_PLACEHOLDER,
  PERMISSION_NAME,
} from "@/constants/constants";
import { hasPermissionUser } from "@/utils/permissionUtils";
export default {
  name: "DanhSachNguoiDungTheoVaiTro",
  mixins: [QuanLyNguoiDung],
  components: {
    XoaNguoiDungModal,
    DanhSachNguoiDungHeThong,
  },
  data() {
    return {
      PERMISSION_NAME,
      NO_RESULTS_TEXT: NO_RESULTS_TEXT,
      TREE_SELECT_PLACEHOLDER: TREE_SELECT_PLACEHOLDER,
      danhSachIdNguoiDungMuonXoa: [],
      vaiTroId: null,
      options: [],
      requestForm: {},
      selectedCanBo: [],
    };
  },
  computed: {
    ...mapGetters({
      danhSachNguoiDung: "user/danhSachNguoiDungTheoVaiTro",
    }),
  },
  props: {
    chiTietVaiTro: {
      type: Object,
      required: true,
    },
    readonly: {
      type: Boolean,
      default: false,
    },
  },
  watch: {
    chiTietVaiTro: {
      handler() {
        if (!_isNil(this.chiTietVaiTro)) {
          this.vaiTroId = this.chiTietVaiTro.id;
          this.layDanhSachNguoiDung();
        }
      },
    },
    danhSachNguoiDung: {
      handler() {
        this.totalPages = this.danhSachNguoiDung.totalPage;
        this.totalRows = _isNil(this.danhSachNguoiDung.totalCount)
          ? 0
          : this.danhSachNguoiDung.totalCount;

        if (!_isEmpty(this.chiTietVaiTro)) {
          this.danhSachNguoiDungNoiBo = this.layDanhSachNguoiDungNoiBo(
            this.danhSachNguoiDung
          );
        }
      },
      deep: true,
    },
    selectedCanBo: {
      handler() {
        this.danhSachIdNguoiDungDaChon = this.selectedCanBo
          .filter((i) => !i.isFromRole && i.canDelete)
          .map((x) => x.id);
      },
      deep: true,
    },
  },
  methods: {
    hasPermissionUser,
    rowClass(rowData) {
      if (rowData.isFromRole) {
        return "disabled-background-row";
      }
      if (!rowData.canDelete) {
        return "disable-select";
      }
      return "";
    },
    xoaNguoiDung(nguoiDungId) {
      this.danhSachIdNguoiDungMuonXoa = [nguoiDungId];
      this.$bvModal.show("xoa-nguoi-dung");
    },
    moFormThemDanhSachNguoiDung() {
      this.$bvModal.show("them-nguoi-dung-modal");
    },
    dongFormThemDanhSachNguoiDung() {
      this.$bvModal.hide("them-nguoi-dung-modal");
    },
    xoaDanhSachNguoiDung() {
      if (
        _isEmpty(this.danhSachIdNguoiDungDaChon) ||
        this.danhSachIdNguoiDungDaChon.length === 0
      ) {
        this.$toasted.clear();
        this.$toasted.global.showErrorMessage({
          message: LOI_CHUA_CHON_NGUOI_DUNG,
        });
        return;
      }
      this.danhSachIdNguoiDungMuonXoa = _cloneDeep(
        this.danhSachIdNguoiDungDaChon
      );
      this.$bvModal.show("xoa-nguoi-dung");
    },
    xoaDanhSachNguoiDungTrongVaiTro() {
      const $vm = this;
      const payload = {
        LstUserCanBoDepartmentRemove: this.danhSachIdNguoiDungMuonXoa,
        roleId: this.vaiTroId,
      };
      this.$store
        .dispatch("role/capNhatNguoiDungTrongVaiTro", payload)
        .then(() => {
          $vm.layDanhSachNguoiDung();
          // $vm.$store.dispatch("user/layDanhSachQuyenTheoNguoiDung", {});
          $vm.$toasted.clear();
          $vm.$toasted.global.showSuccessMessage({
            message: XOA_NGUOI_DUNG_THANH_CONG,
          });
          this.danhSachIdNguoiDungDaChon =
            this.danhSachIdNguoiDungDaChon.filter(
              (x) => !this.danhSachIdNguoiDungMuonXoa.includes(x)
            );
        })
        .catch((error) => {
          $vm.$toasted.clear();
          if (
            !_isEmpty(error.response) &&
            error.response.data.Errors.length > 0
          ) {
            $vm.$toasted.global.showErrorMessage({
              message: error.response.data.Errors[0].Description,
            });
          }
        });
    },
    layDanhSachNguoiDung() {
      if (this.vaiTroId) {
        const payload = {
          ...this.requestInformation,
          roleId: this.vaiTroId,
        };
        this.isLoadingTable = true;
        this.$store
          .dispatch("user/layDanhSachNguoiDungTheoVaiTro", payload)
          .then(() => {
            this.isLoadingTable = false;
          });
      }
    },
    layDanhSachNguoiDungNoiBo(danhSachNguoiDung) {
      if (_isEmpty(danhSachNguoiDung.items)) {
        return [];
      }
      return danhSachNguoiDung.items.map((item, index) => {
        return {
          checkbox: null,
          stt:
            (this.requestInformation.pageIndex - 1) *
              this.requestInformation.pageSize +
            index +
            1,
          userId: _isNil(item.userId) ? "" : item.userId,
          id: _isNil(item.id) ? "" : item.id,
          userName: _isNil(item.userName) ? "" : item.userName,
          name: _isNil(item.name) ? "" : item.name,
          donVi: _isNil(item.donVi) ? "" : item.donVi,
          chucVu: _isNil(item.chucVu) ? "" : item.chucVu,
          email: _isNil(item.email) ? "" : item.email,
          canDelete: item.canDelete,
          thaoTac: "thaoTac",
        };
      });
    },
  },
};
</script>

<style lang="scss">
.danh-sach-nguoi-dung-theo-vai-tro {
  .label-table {
    font-size: 16px !important;
    margin-top: 3px;
    margin-right: 5px;
    margin-left: -5px;
    font-weight: bold;
  }
  .disable-select {
    .select-column {
      .p-checkbox.p-component {
        display: none;
      }
    }
  }
}
</style>
